import { Button as AntButton } from "antd";
import { ModalProps } from ".";
import Button from "../button";

import { StyledFooterContent } from "./styles";

const ModalFooter = ({ footerExtra, cancelText, okText, confirmLoading, onCancel, onOk }: ModalProps): JSX.Element => (
  <StyledFooterContent>
    <div className="extra">{footerExtra}</div>
    <div className="alignButtons">
      {onCancel && (
        <AntButton onClick={onCancel} className="cancel" type="text">
          {cancelText}
        </AntButton>
      )}

      {onOk && (
        <Button loading={confirmLoading} onClick={onOk} color="primary" variant="contained">
          {okText}
        </Button>
      )}
    </div>
  </StyledFooterContent>
);

export default ModalFooter;
